require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-relazioni-e-conferenze-matteo-iannello-architettura-scolastica-nel-cantone-ticino-iuav-venezia-3-dicembre-2021.json") })
        }
      }, "path---en-relazioni-e-conferenze-matteo-iannello-architettura-scolastica-nel-cantone-ticino-iuav-venezia-3-dicembre-2021");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-relazioni-e-conferenze-matteo-iannello-architettura-scolastica-nel-cantone-ticino-iuav-venezia-3-dicembre-2021!./.cache/json/en-relazioni-e-conferenze-matteo-iannello-architettura-scolastica-nel-cantone-ticino-iuav-venezia-3-dicembre-2021.json
// module id = 618
// module chunks = 231608221292675